module.exports = __webpack_public_path__ + "img/ed991bd.jpg";